import type { Cb, Nodes } from "./helpers.types"

export const getWidthVariable = (index: number) => `--col-${index}`

export const setWidthVariable = (nodes: Nodes | undefined, cb: Cb) => {
  if (!nodes) return

  let index = 0

  nodes.forEach((node) => {
    if (node.matches(".ant-table-selection-col")) return

    const result = cb(node, { index, widthVariable: getWidthVariable(index) })

    if (result === false) return

    index += 1
  })
}
